var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"viewer-loading"},[_c('div',{staticClass:"spinner",attrs:{"aria-hidden":"true"}}),_c('h2',[_vm._v("Preparing slide viewer...")]),_c('p',[_vm._v("Loading visualization modules")])])
}]

export { render, staticRenderFns }